/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    manual: PropTypes.bool,
    orientation: PropTypes.oneOfType([
        PropTypes.oneOf(['top', 'bottom', 'right', 'left']),
        PropTypes.arrayOf(PropTypes.oneOf([
            'top',
            'bottom',
            'right',
            'left',
        ])),
    ]),
    scrollable: PropTypes.bool,
    visible: PropTypes.bool,
    width: PropTypes.oneOf([
        'xs',
        's',
        'l',
        'xl',
        'full',
        'mid',
        'full-with-sidebar',
    ]),
};

const defaultProps = {
    ...commonDefaultProps,
    manual: false,
    orientation: 'top',
    scrollable: false,
    visible: false,
    width: 's',
};

const Tooltip = (props) => {
    let orientationClasses = null;
    if (Array.isArray(props.orientation)) {
        orientationClasses = _.map(props.orientation, (currentOrientation) => `c-tooltip_${currentOrientation}`);
    } else {
        orientationClasses = `c-tooltip_${props.orientation}`;
    }
    const classNames = [
        'c-tooltip',
        props.scrollable ? 'c-tooltip__scrollable' : '',
        props.visible ? 'c-tooltip_visible' : '',
        props.manual ? 'c-tooltip_manual' : '',
        `c-tooltip_${props.width}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ].concat(orientationClasses);
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Tooltip.propTypes = propTypes;

Tooltip.defaultProps = defaultProps;

export default Tooltip;
